import '@dreamstack/datadog/init' // Initialize datadog with side-effects
import { ExitPreview } from '@dreamstack/feature-components/src/layout/ExitPreview'
import { createEmotionCache } from '@dreamstack/theme'
import '@dreamstack/theme/src/lib/UserCentricsStyle.css'
import type { EmotionCache } from '@emotion/cache'
import { CacheProvider } from '@emotion/react'
import { SpeedInsights } from '@vercel/speed-insights/react'
import 'keen-slider/keen-slider.min.css'
import type { AppProps } from 'next/app'
import Head from 'next/head'
import { MainProvider } from '../components/provider/MainProvider'
import '../public/fonts/fontfaces.css'
import '../tailwind.css'

// React needs to be imported here... Things break a lot if we dont
import { trpc } from '@dreamstack/trpc/client'
import type { AppContextType } from 'next/dist/shared/lib/utils'
import React from 'react'
import { RefreshRouteOnSave } from '../lib/payload/RefreshRouteOnSave'
const preventReactImportRemovalOnSave = React

const clientSideEmotionCache = createEmotionCache()

interface CustomAppProps extends AppProps {
  emotionCache?: EmotionCache
}

function CustomApp({
  Component,
  pageProps,
  emotionCache = clientSideEmotionCache,
}: CustomAppProps) {
  return (
    <CacheProvider value={emotionCache}>
      <>
        <Head>
          <title>DreamStack</title>
        </Head>
        <MainProvider pageProps={pageProps}>
          <RefreshRouteOnSave />
          <ExitPreview />
          <Component {...pageProps} />
          <SpeedInsights />
        </MainProvider>
      </>
    </CacheProvider>
  )
}

CustomApp.getInitialProps = async (appContext: AppContextType) => {
  const context = appContext.ctx as any
  if (appContext.router.isPreview) {
    context.HACKY_IS_PREVIEW = true
  }
  return {}
}

export default trpc.withTRPC(CustomApp)
